// The currency symbol of the account that OWNS the canvas being shown (the
// canvas GET / shared-link payload carries `currency: {code, symbol}`). Chart
// resolution reads it as the default for a "currency" number format; a symbol
// the reader stored on the chart wins, and with no account symbol it is "$".
//
// Module state rather than a prop because the resolver is called from a dozen
// places (card, settings panel, exports, view toggle) that all render one
// canvas at a time; the page sets it before it sets the canvas.

let symbol = '';

export function setCanvasCurrency(currency) {
    symbol = currency && typeof currency.symbol === 'string' ? currency.symbol : '';
}

/** Options for resolveBlockCharts / resolveChart / defaultLook. */
export function canvasResolveOpts() {
    return symbol ? { currency: symbol } : undefined;
}
